<template>
  <div class="bg-white">
    <div class="flex flex-col space-y-3 md:space-y-0 md:flex-row md:space-x-4">
      <div>
        <sqr-input-date
          :label="$t('invoice_date')"
          :value="invoice.date"
          @change="change('date', $event)"
          :v="$v.invoice.date"
        />
        <div
          class="help is-danger"
          v-if="$v && $v.invoice.date.$error && !$v.invoice.date.emission"
        >
          {{ $t('validation_invoice_emission') }}
        </div>
      </div>
      <div class="flex flex-row items-end">
        <sqr-input-text
          class="mr-1"
          :label="$t('invoice_number')"
          :value="invoice.number"
          @change="change('number', $event)"
          :v="$v.invoice.number"
        />
        <sqr-button
          :tooltip="$t('invoice_number_regenerate')"
          @click="$emit('number-new', {})"
          color="white"
        >
          <template slot="icon">
            <RefreshIcon class="inline w-4 h-4 stroke-current" />
          </template>
        </sqr-button>
      </div>
      <div>
        <sqr-input-select
          :label="$t('invoice_reason')"
          :value="invoice.reason"
          :options="reasons"
          @change="change('reason', $event)"
          :v="$v.invoice.reason"
        />
      </div>
      <div>
        <sqr-input-checkboxes
          box-class="grid-cols-2 gap-x-4 mt-2"
          :label="$t('invoice_copies')"
          :value="invoice.copies"
          @change="change('copies', $event)"
          :options="copies"
          horizontal
        />
      </div>
      <div>
        <sqr-input-checkbox
          :label="$t('invoice_details')"
          :placeholder="$t('invoice_details_placeholder')"
          :value="invoice.details"
          @change="change('details', $event)"
          option-class="mt-2"
        />
      </div>
    </div>
    <div v-if="invoice.details" class="-mx-4 my-4 p-4 bg-gray-100">
      <div class="grid grid-cols-6 gap-x-6 gap-y-3">
        <sqr-input-textarea
          class="col-span-6"
          label="invoice_note"
          :value="invoice.note"
          @change="change('note', $event)"
          :rows="2"
        />
        <sqr-input-select
          class="col-span-2"
          :label="$t('invoice_diagnostic_type')"
          :value="invoice.diagnosticType"
          :options="diagnostics"
          @change="change('diagnosticType', $event)"
        />
        <sqr-input-text
          class="col-span-2"
          :label="$t(`invoice_diagnostic_${invoice.diagnosticType || 'text'}`)"
          :value="invoice.diagnosticText"
          @change="change('diagnosticText', $event)"
        />
        <sqr-input-date
          class="col-start-1 col-span-2"
          :label="$t('invoice_gaprch')"
          :placeholder="$t('invoice_gaprch_date')"
          :value="invoice.gaprchDate"
          @change="change('gaprchDate', $event)"
        />
        <sqr-input-text
          class="col-span-2"
          :label="$t('invoice_gaprch_number')"
          :value="invoice.gaprchNumber"
          @change="change('gaprchNumber', $event)"
        />
        <sqr-input-date
          class="col-start-1 col-span-2"
          :label="$t('invoice_reminder')"
          :placeholder="$t('invoice_reminder_date')"
          :value="invoice.reminderDate"
          @change="change('reminderDate', $event)"
        />

        <sqr-input-text
          class="col-span-2"
          :label="$t('invoice_reminder_number')"
          :value="invoice.reminderNumber"
          @change="change('reminderNumber', $event)"
        />

        <sqr-input-text
          class="col-start-1 col-span-2"
          :label="$t('invoice_mandatary_gln')"
          :value="invoice.mandataryGln"
          @change="change('mandataryGln', $event)"
        />
        <sqr-input-text
          class="col-span-2"
          :label="$t('invoice_mandatary_rcc')"
          :value="invoice.mandataryDate"
          @change="change('mandataryDate', $event)"
        />
        <sqr-input-text
          class="col-span-2"
          :label="$t('invoice_mandatary_name')"
          :value="invoice.mandataryName"
          @change="change('mandataryName', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SqrButton from '@/components/SqrButton';
import SqrInputDate from '@/components/SqrInputDate';
import SqrInputText from '@/components/SqrInputText';
import SqrInputSelect from '@/components/SqrInputSelect';
import SqrInputCheckbox from '@/components/SqrInputCheckbox';
import SqrInputCheckboxes from '@/components/SqrInputCheckboxes';
import SqrInputTextarea from '@/components/SqrInputTextarea';
import { RefreshIcon } from '@vue-hero-icons/outline';

export default {
  name: 'InvoiceForm',
  components: {
    SqrButton,
    SqrInputDate,
    SqrInputText,
    SqrInputCheckbox,
    SqrInputCheckboxes,
    SqrInputSelect,
    SqrInputTextarea,
    RefreshIcon
  },
  props: {
    invoice: { type: Object, default: () => ({}) },
    validations: { type: Object, default: () => ({}) }
  },
  computed: {
    $v() {
      return this.validations;
    },
    reasons() {
      return [
        'illness',
        'accident',
        'pregnency',
        'prevention',
        'congenital',
        'unknown'
      ].map(id => ({ id, label: this.$t('invoice_reason_' + id) }));
    },
    copies() {
      return ['patient', 'issuer'].map(id => ({
        id,
        label: this.$t('invoice_copies_' + id)
      }));
    },
    diagnostics() {
      return ['text', 'idc10', 'icpc', 'ticode'].map(id => ({
        id,
        label: this.$t('invoice_diagnostic_' + id)
      }));
    }
  },
  methods: {
    change(field, value) {
      this.$emit('change', { field, value });
    }
  }
};
</script>
